/* DreamWrap product page behaviour. Loaded ONLY by sections/ew-dw-kit.liquid (DreamWrap template). */
(function () {
  'use strict';

  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }

  /* 1. Small line above the title and the subtitle below it.
        Both are custom blocks in the template (so the text stays editable in the theme editor);
        the theme renders blocks after the title, so they are moved into the title area here. */
  function moveTitleBits() {
    var header = document.querySelector('.product-single__meta .product-block--header');
    var title = header && header.querySelector('.product-single__title');
    if (!title) return;
    var eyebrow = document.querySelector('.product-single__meta .ew-dw-eyebrow.ew-dw-move');
    var subtitle = document.querySelector('.product-single__meta .ew-dw-subtitle.ew-dw-move');
    [[eyebrow, 'before'], [subtitle, 'after']].forEach(function (pair) {
      var el = pair[0]; if (!el) return;
      var block = el.closest('.product-block');
      title.insertAdjacentElement(pair[1] === 'before' ? 'beforebegin' : 'afterend', el);
      el.classList.add('is-moved');
      if (block && !block.textContent.trim()) block.hidden = true;
    });
  }

  /* 2. Washing-machine hint that follows the chosen size.
        The texts live on the block itself: data-small for the two small sizes, data-large otherwise. */
  function sizeValue() {
    var sel = document.querySelector('.product-single__meta .swatch-selector.swatch-selected[swatch-option="option1"]');
    if (sel) return sel.getAttribute('data-value');
    var select = document.querySelector('.product-single__meta select[data-index="option1"]');
    return select ? select.value : '';
  }
  function updateWasher() {
    var box = document.querySelector('.ew-dw-washer [data-small]'); if (!box) return;
    var small = (box.getAttribute('data-small-sizes') || '').split('|');
    var size = sizeValue();
    box.textContent = small.indexOf(size) > -1 || !size ? box.getAttribute('data-small') : box.getAttribute('data-large');
  }

  /* 3. "Größen- & Waschguide" link next to the size label: opens the Spezifikationen fold-out. */
  function addGuideLink() {
    var label = document.querySelector('.product-single__meta .swatch-single:has([swatch-option="option1"]) .swatch-label');
    if (!label || label.querySelector('.ew-dw-guide')) return;
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'ew-dw-guide'; btn.textContent = 'Größen- & Waschguide';
    btn.setAttribute('aria-haspopup', 'dialog');
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      openGuide(btn);
    });
    label.appendChild(btn);
  }

  /* 3b. Größen- & Waschguide popup (native <dialog>: focus stays inside, Esc closes it) */
  var lastOpener = null;
  function guideDialog() { return document.querySelector('dialog[data-ew-dw-guide]'); }
  function openGuide(opener) {
    var dlg = guideDialog(); if (!dlg) return;
    /* the block sits inside the product column; the top layer ignores that, but move it to <body>
       so no parent styling (overflow, transform) can ever clip it */
    if (dlg.parentElement !== document.body) document.body.appendChild(dlg);
    lastOpener = opener || null;
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    document.documentElement.classList.add('ew-dw-lock');
  }
  function closeGuide() {
    var dlg = guideDialog(); if (!dlg || !dlg.open) return;
    if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
  }
  function wireGuide() {
    var dlg = guideDialog(); if (!dlg || dlg.dataset.wired) return;
    dlg.dataset.wired = '1';
    dlg.addEventListener('click', function (e) {
      /* a click on the dimmed area (the wrapper around the card) closes it, like on Softest Hours */
      if (e.target.closest('[data-ew-dw-guide-close]') || !e.target.closest('.ew-dw-dialog__card')) closeGuide();
    });
    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('ew-dw-lock');
      if (lastOpener) lastOpener.focus();
    });
  }

  /* 4. First FAQ question open, as on Softest Hours */
  function openFirstFaq() {
    var first = document.querySelector('[id$="__faq"] .collapsible-trigger');
    if (first && !first.classList.contains('is-open')) first.click();
  }

  ready(function () {
    moveTitleBits();
    wireGuide();
    setTimeout(openFirstFaq, 400);
    updateWasher();
    /* Swatch King builds its picker after load; retry until it is there */
    var tries = 0, t = setInterval(function () {
      addGuideLink(); updateWasher();
      if (++tries > 20 || document.querySelector('.ew-dw-guide')) clearInterval(t);
    }, 300);
    document.addEventListener('click', function (e) {
      if (e.target.closest('.swatch-selector, .swatch-view-item')) setTimeout(function () { updateWasher(); addGuideLink(); }, 120);
    });
    document.addEventListener('change', function () { setTimeout(updateWasher, 60); });
  });
})();
